import { combineReducers } from 'redux';
import { loadingStatusAccordingToReducer } from 'utils/reducers/loading-status/loading-status';
import games from './games';
import packs from './packs';
import userSelection from './user-selection';
import packDetails from './pack-details';
import orderDetails from './order-details';
import liabilities from './liabilities';
import packGrossValue from './packs-gross-value';
import orderHistory from './order-history';

import instantGamesTransitionsHistory from './instant-games-transitions-history';

const manageInventory = combineReducers({
  games,
  packs,
  instantGamesTransitionsHistory,
  userSelection,
  packDetails,
  orderDetails,
  liabilities,
  packGrossValue,
  orderHistory,
  isLoading: loadingStatusAccordingToReducer('manageInventoryLoadingStatus'),
  packDetailsLoadingStatus: loadingStatusAccordingToReducer('packDetailsLoadingStatus'),
  orderDetailsLoadingStatus: loadingStatusAccordingToReducer('orderDetailsLoadingStatus'),
  orderHistoryLoadingStatus: loadingStatusAccordingToReducer('orderHistoryLoadingStatus'),
});

export default manageInventory;



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/reducers/manage-inventory.reducer.js